export const ROUTES = {
  home: `/`,
  test: '/test',
  customLogin: '/custom_login',
  permissionDenied: '/permission_denied',
  error500: '/something_went_wrong',
  validationFailed: '/validation_failed',
  notFound: '/not_found',
  anyPage: '*',
}